import styled from '@emotion/styled'
import { InfiniteLoader } from 'components/infiniteLoader/InfiniteLoader'
import { Button } from 'components/button/Button'
import { Stack } from 'components/Stack'

export const SStackAsDropzone = styled(Stack)<{ isDragActive?: boolean }>`
  outline: none;
  border: 2px solid transparent;
  ${({ isDragActive }) =>
    isDragActive &&
    `
      box-sizing: initial;
      border: 2px dashed var(--c-blue300);
      background-color: var(--c-blue100);
    `}
`

export const SInfiniteLoader = styled(InfiniteLoader)`
  width: 100%;
`

export const SAddButton = styled(Button)`
  height: unset;
  padding: 1rem;

  & > span {
    display: flex;
    flex-direction: column;
    align-items: center;

    & > svg {
      margin-bottom: 0.5rem;
    }
  }
`
